import type { useClerk } from "@clerk/react";

type Clerk = ReturnType<typeof useClerk>;

// The loaded Clerk instance, for code outside React (axios interceptors, helpers).
// Set by ClerkBridge in main.tsx.
let clerk: Clerk | null = null;

export const setClerk = (instance: Clerk) => {
  clerk = instance;
};

/** A fresh Clerk session token (Clerk refreshes it in the background), or null when signed out. */
export const getSessionToken = async (): Promise<string | null> => {
  return (await clerk?.session?.getToken()) ?? null;
};

/** Seconds left before the Clerk session ends; 0 if signed out or already expired. */
export const getSessionSecondsLeft = (): number => {
  const expireAt = clerk?.session?.expireAt;

  if (!expireAt) {
    return 0;
  }

  return Math.max(0, Math.floor((expireAt.getTime() - Date.now()) / 1000));
};

/** Signs out of Clerk, then does a full reload so no cached data from this user survives. */
export const signOut = async (): Promise<void> => {
  try {
    await clerk?.signOut();
  } finally {
    window.location.assign("/auth/login");
  }
};
